import {Button, Dialog, DialogActions, DialogContent, MenuItem, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import useAppContext from "../../util/AppContext";
import CCInputLabel from "../Common/CCInputLabel";
import CCSelect from "../Common/CCSelect";
import css_shared from "./css/LoginCommon.module.scss";
import css_self from "./css/LoginMain.module.scss";
import axios from "axios";
import enlilImage from "../../assets/logo-5cd08655.svg";
import {Blue3} from "../../theme/styles";
import CCPulse from "../Common/CCPulse";
import EventBus from "../../util/EventBus";

export function SwitchCompany() {

    const {sessionContext} = useAppContext();

    const [submitting, setSubmitting] = useState(false);

    const [companies, setCompanies] = useState([]);
    const [displayedCompany, setDisplayedCompany] = useState("");
    const [displayedCompanies, setDisplayedCompanies] = useState([]);
    const [displayedVisibility, setDisplayedVisibility] = useState(null);

    useEffect(() => {
        init().then(() => {})

    }, []);

    async function switchCompany() {
        // @ts-ignore
        axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t8/v1/authenticate",
            json: true,
            data: {
                "X-Enlil-RefreshToken": sessionContext.getRefreshToken(),
                "ChangeRealm": companies[displayedCompany]["CompanyUSID"],
                "Visibility": displayedVisibility
            },
        }).then(response => {
            let visibilityMode, visibilityValue
            if (displayedVisibility) {
                [, visibilityMode, visibilityValue] = displayedVisibility.split(":");
            } else {
                visibilityMode = "Position"
                visibilityValue = response.data["Company"]["Positions"][0].USID
            }

            sessionContext.setActiveVisibility(visibilityMode, visibilityValue)
            sessionContext.setIdentityToken(response.data["IdentityToken"])
            sessionContext.setSessionUSID(response.data["Session"])
            sessionContext.setAccessToken(response.data["AccessToken"])
            sessionContext.setRefreshToken(response.data["RefreshToken"])
            sessionContext.setCompanyName(response.data["Company"]["CompanyName"])
            sessionContext.setEmployeeUSID(response.data["Company"]["EmployeeUSID"])
            sessionContext.setCompany(response.data["Company"])
            sessionContext.setRoles(response.data["Roles"])
            sessionContext.setPrivileges(response.data["NewPrivileges"])
            sessionContext.setTenants(response.data["Tenants"])
            sessionContext.setShowLoginDialog(false)
            sessionContext.setPickValues(response.data["PickValues"])
            sessionContext.setS3AccessKeyId(response.data["S3AccessKeyId"])
            sessionContext.setS3SecretAccessKey(response.data["S3SecretAccessKey"])
            sessionContext.setS3SessionToken(response.data["S3SessionToken"])

            window.location.href="/";
        }).catch(() => {
            EventBus.error.emit("show-system-error");
        });
    }

    function default_visibility(companies, company_name) {

        if (Object.keys(companies).length > 0 && company_name in companies) {

            const company = companies[company_name];
            const companyUSID = company["companyUSID"];

            if (company["Positions"].length > 0) {
                const position = company["Positions"];
                return `${companyUSID}:Position:${position["USID"]}`;
            }

            if (company["UserGroups"].length > 0) {
                const userGroup = company["UserGroups"];
                return `${companyUSID}:UserGroup:${userGroup["USID"]}`;
            }

            if (company["WorkGroups"].length > 0) {
                const workgroup = company["WorkGroups"];
                return `${companyUSID}:WorkGroup:${workgroup["USID"]}`;
            }
        }

        return null;
    }

    async function login() {
        return await axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t8/v1/authenticate",
            json: true,
            headers: {},
            data: {
                "X-Enlil-RefreshToken": sessionContext.getRefreshToken(),
                "SwitchCompany": true
            }
        }).catch(e => e.response || e);
    }

    async function init() {
        let result = await login();

        const companies = result.data["Companies"];

        const displayedCompanies = Object.keys(companies).sort();
        const displayedCompany = displayedCompanies[0];
        const displayedVisibility = default_visibility(companies, displayedCompany);

        setCompanies(companies);

        setDisplayedCompany(displayedCompany);
        setDisplayedCompanies(displayedCompanies);
        setDisplayedVisibility(displayedVisibility);
    }

    let loginFormToPresent = null;

    if (displayedCompanies.length >= 1) {

        let menuItems = [];

        for (let i = 0; i < companies[displayedCompany]["Positions"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"positions"} key={i + 1000}>Positions</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const position = companies[displayedCompany]["Positions"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:Position:${position["USID"]}`} key={i}>&emsp;{position["Name"]}</MenuItem>);
        }

        for (let i = 0; i < companies[displayedCompany]["UserGroups"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"userGroups"} key={i + 1500}>User Groups</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const userGroup = companies[displayedCompany]["UserGroups"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:UserGroups:${userGroup["USID"]}`} key={i + 50}>&emsp;{userGroup["Name"]}</MenuItem>);
        }

        for (let i = 0; i < companies[displayedCompany]["WorkGroups"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"workgroups"} key={i + 2000}>Workgroups</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const workgroup = companies[displayedCompany]["WorkGroups"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:WorkGroup:${workgroup["USID"]}`} key={i + 100}>&emsp;{workgroup["Name"]}</MenuItem>);
        }

        loginFormToPresent = (
            <>
                <Typography className={css_shared.Title}>Select your company and persona</Typography>
                <CCInputLabel>Company</CCInputLabel>
                <CCSelect
                    size={"small"}
                    fullWidth={true}
                    value={displayedCompany}
                    onChange={e => {
                        setDisplayedCompany(e.target.value);
                        setDisplayedVisibility(default_visibility(companies, e.target.value));
                    }}
                >
                    {displayedCompanies.map(company => (
                        <MenuItem value={company} key={`select-company-${company}`}>{company}</MenuItem>
                    ))}
                </CCSelect>
                <CCInputLabel>Persona</CCInputLabel>
                <CCSelect
                    size={"small"}
                    fullWidth={true}
                    value={displayedVisibility}
                    onChange={e => setDisplayedVisibility(e.target.value)}
                >
                    {menuItems}
                </CCSelect>
                <Button
                    {...{"data-cc-component": "CCLoginButton"}}
                    {...{"data-animate": submitting}}
                    fullWidth
                    disabled={
                        submitting || (displayedCompanies.length > 0 && (displayedVisibility === null || displayedVisibility.length === 0))
                    }
                    onClick={() => {
                        switchCompany();
                    }}
                >
                    <span style={submitting ? {visibility: "hidden"} : undefined}>Select</span>
                    {submitting ? <CCPulse className={css_self.Pulse} /> : undefined}
                </Button>
            </>
        );
    }

    return (
        <Dialog maxWidth="md" open={true} scroll="body">
            <DialogContent style={{padding: "0 16px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    <div>
                        <img className={css_self.EnlilLogo} src={enlilImage} alt="Home"/>
                    </div>
                    <div style={{marginTop: "10px"}}>
                        <span style={{marginLeft: "65px", fontSize: 25, fontWeight: 400, color: Blue3}}>| PM</span>
                    </div>
                </div>
                {loginFormToPresent}
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );

}
